import HttpService from './commons/HttpService';

const ProductService = {
  save(products) {
    if (products.id && products.id > 0) {
      return this.update(products);
    }
    return this.create(products);
  },
  create(products) {
    return HttpService.post('/products', products);
  },
  update(products) {
    return HttpService.put(`/products/${products.id}`, products);
  },
  delete(products) {
    return HttpService.delete(`/products/${products.id}`);
  },
  getById(id) {
    return HttpService.get(`/products/${id}`);
  },
  findAllForCurrentUser() {
    return HttpService.get('/products');
  },
  findProductStockInfo() {
    return HttpService.get('/products/stock');
  },
  findProductStockInfoByProductId(productId) {
    return HttpService.get('/products/stockProduct', { params: { productId } });
  },
  searchForCurrentUser(query) {
    return HttpService.get('/products/search', { params: { query } });
  },
  createManualStockMovement(productManualStock) {
    return HttpService.post(`/products/${productManualStock.productId}/manualStocks`, productManualStock);
  },
  getStockMovementHistory({ productId, year }) {
    return HttpService.get(`/products/${productId}/stockHistory`, { params: { productId, year } });
  },

  updateImage({ productId, file }) {
    const formData = new FormData();
    formData.append('file', file);

    const config = { headers: { 'content-type': 'multipart/form-data' } };
    return HttpService.put(`/products/${productId}/image`, formData, config);
  },
  deleteImage(productId) {
    return HttpService.delete(`/products/${productId}/image`);
  },
};
export default ProductService;
